"use client";

import React, { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { useAppSelector } from "@/redux/hooks";
import { ISetting } from "@/modules/setting/settingModel";
import { FaWhatsapp } from "react-icons/fa";

export const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const SettingList = useAppSelector((state) => state.home.SettingList);
  const Settings: Record<string, ISetting> = SettingList?.reduce(
    (acc, item) => {
      acc[item?.SettingKey] = item;
      return acc;
    },
    {} as Record<string, ISetting>,
  );

  const WhatsAppNo = Settings?.["WhatsAppNo"]?.SettingValue;
  const WhatsAppNo2 = Settings?.["WhatsAppNo2"]?.SettingValue;
  const phone = WhatsAppNo ? WhatsAppNo.replace(/\D+/g, "") : "";
  const whatsappLink = phone
    ? `https://wa.me/${phone}?text=${encodeURIComponent("Hello, I'd like to know more details.")}`
    : "#";
  const phone2 = WhatsAppNo2 ? WhatsAppNo2.replace(/\D+/g, "") : "";
  const whatsappLink2 = phone2
    ? `https://wa.me/${phone2}?text=${encodeURIComponent("Hello, I'd like to know more details.")}`
    : "#";

  useEffect(() => {
    // Only show if UserGUID is NOT present (Website mode)
    const userGUID = localStorage.getItem("UserGUID");
    if (!userGUID) {
      setIsVisible(true);
    }
  }, []);

  if (!isVisible) return null;

  const contacts = [
    ...(WhatsAppNo ? [{ name: WhatsAppNo, link: whatsappLink }] : []),
    ...(WhatsAppNo2 ? [{ name: WhatsAppNo2, link: whatsappLink2 }] : []),
  ];

  return (
    <div className="fixed bottom-7 right-7 z-[9999] flex flex-col gap-3 items-end">
      {contacts.map((contact, i) => (
        <a
          key={i}
          href={contact.link}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center gap-2.5 bg-[#25D366] text-white px-3 py-3 rounded-full font-semibold text-[13px] shadow-[0_4px_24px_rgba(37,211,102,0.3)] hover:scale-[1.04] transition-all group lg:flex"
        >
          <FaWhatsapp className="text-lg" />
          <span className="tracking-wide hidden md:block group-hover:block transition-all duration-300">
            {contact.name}
          </span>
        </a>
      ))}
    </div>
  );
};
